import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LOGIN } from '../../lib/routes';
import useRegisterAccount from '../../hooks/auth/useRegisterAccount';

const Register = () => {
  const navigate = useNavigate();
  const { register, error, isRegistering } = useRegisterAccount();

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await register(form);
    if (!error) {
      navigate('/home');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-purple-900 to-black flex items-center justify-center px-4 relative overflow-hidden text-white">
      
      <div className="absolute inset-0 bg-[radial-gradient(#6b21a8_1px,transparent_1px)] bg-[size:20px_20px] opacity-10 animate-pulse z-0" />

      <div className="relative z-10 bg-[#0f0a1c] border border-purple-700 shadow-[0_0_60px_rgba(139,92,246,0.5)] rounded-2xl px-8 py-10 w-full max-w-lg">
        
        <h2 className="text-4xl font-extrabold mb-6 text-center text-purple-400 tracking-wide">
          Register for <span className="text-white">LootLayer</span>
        </h2>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="flex space-x-4">
            <div className="w-1/2">
              <label className="block text-sm font-semibold mb-2">First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="John"
                value={form.firstName}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-gray-900 border border-purple-600 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-semibold mb-2">Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Doe"
                value={form.lastName}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-gray-900 border border-purple-600 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">Email</label>
            <input
              type="email"
              name="email"
              placeholder="you@lootlayer.com"
              value={form.email}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-gray-900 border border-purple-600 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">Password</label>
            <input
              type="password"
              name="password"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-gray-900 border border-purple-600 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
            />
          </div>

          {error && (
            <p className="text-red-400 text-sm text-center mt-2">{error}</p>
          )}

          <button
            type="submit"
            disabled={isRegistering}
            className="w-full bg-gradient-to-r from-purple-600 to-purple-800 hover:to-purple-900 text-white font-semibold py-3 rounded-lg shadow-lg uppercase tracking-wide transition-all"
          >
            {isRegistering ? 'Registering...' : 'Create Account'}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-purple-300">
          Already have an account?{' '}
          <Link to={LOGIN} className="underline hover:text-purple-400 font-semibold">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
